import React from "react";
import "./Skills.css";

import { FaReact, FaJava, FaHtml5, FaCss3Alt, FaGitAlt, FaGithub, FaBootstrap } from "react-icons/fa";
import { SiJavascript, SiSpringboot, SiMysql, SiPostman, SiRedux, SiFirebase, SiFlutter, SiAndroid } from "react-icons/si";

const frontend = [
  { name: "JavaScript (ES6+)", icon: <SiJavascript />, color: "#d4b106" },
  { name: "Redux", icon: <SiRedux />, color: "#764ABC" },
  { name: "HTML5", icon: <FaHtml5 />, color: "#E34F26" },
  { name: "CSS3", icon: <FaCss3Alt />, color: "#1572B6" },
  { name: "Bootstrap", icon: <FaBootstrap />, color: "#7952B3" },
];

const backend = [
  { name: "Java", icon: <FaJava />, color: "#E76F00" },
  { name: "Spring Boot", icon: <SiSpringboot />, color: "#6DB33F" },
  { name: "MySQL", icon: <SiMysql />, color: "#00758F" },
  { name: "Firebase", icon: <SiFirebase />, color: "#E0A800" },
];

const more = [
  { name: "Git", icon: <FaGitAlt />, color: "#F05032" },
  { name: "GitHub", icon: <FaGithub />, color: "#1d1a17" },
  { name: "Postman", icon: <SiPostman />, color: "#FF6C37" },
  { name: "Android", icon: <SiAndroid />, color: "#2fa866" },
  { name: "Flutter", icon: <SiFlutter />, color: "#02A8F3" },
];

const Chip = ({ s }) => (
  <div className="skill-chip" style={{ "--c": s.color }}>
    <span className="skill-icon">{s.icon}</span>
    {s.name}
  </div>
);

const Skills = () => {
  return (
    <section className="section skills" id="skills">
      <div className="container">
        <span className="section-tag reveal">My skills</span>
        <h2 className="section-title reveal" style={{ "--d": "80ms" }}>
          Built around <em>React</em>, backed by Java
        </h2>
        <p className="section-sub reveal" style={{ "--d": "140ms" }}>
          React and modern frontend tooling are my daily drivers. The backend
          stack below is what I reach for to ship complete products.
        </p>

        <div className="skills-layout">
          <div className="card react-card reveal">
            <FaReact className="react-bg" />
            <span className="pill">Primary</span>
            <h3>React.js</h3>
            <p>
              Hooks, context, routing, state management, performance tuning and
              reusable component libraries.
            </p>
            <ul>
              <li>Hooks & custom hooks</li>
              <li>React Router</li>
              <li>Redux state management</li>
              <li>REST API integration (Axios)</li>
              <li>Responsive & accessible UI</li>
            </ul>
          </div>

          <div className="skills-right">
            <div className="card skill-group reveal" style={{ "--d": "80ms" }}>
              <h4>Frontend toolkit</h4>
              <div className="skill-list">{frontend.map((s) => <Chip s={s} key={s.name} />)}</div>
            </div>
            <div className="card skill-group reveal" style={{ "--d": "140ms" }}>
              <h4>Backend &amp; data</h4>
              <div className="skill-list">{backend.map((s) => <Chip s={s} key={s.name} />)}</div>
            </div>
            <div className="card skill-group reveal" style={{ "--d": "200ms" }}>
              <h4>Tools &amp; mobile</h4>
              <div className="skill-list">{more.map((s) => <Chip s={s} key={s.name} />)}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
